/** Settings › Memory: the review queue, proposals, summaries and memory settings. */
export default {
  loadingMemory: "Loading memory…",
  nothingToReview: "Nothing to review.",
  needsReview: {
    one: "{count} memory needs your review.",
    other: "{count} memories need your review.",
  },
  toReview: "To review",
  acceptAll: "Accept all",
  acceptMemory: "Accept memory",
  rejectMemory: "Reject memory",
  showMore: "Show more",
  recentDecisions: "Recent decisions",
  undo: "Undo",
  loadError: "Couldn’t load memory. Try again.",
  loadMoreError: "Couldn’t load more memories. Try again.",
  saveFailures: {
    one: "{count} change couldn’t be saved. Try again.",
    other: "{count} changes couldn’t be saved. Try again.",
  },
  saveChangesError: "Couldn’t save your changes. Try again.",

  settingsLoadError: "Couldn’t load memory settings.",
  settingsSaveError: "Couldn’t save memory settings. Try again.",
  knowledgeGraph: "Knowledge graph",
  knowledgeGraphLine: "Remember useful context across conversations",
  upgrade: "Upgrade",
  openGraph: "Open graph",
  things: { one: "{count} thing", other: "{count} things" },
  model: "Model",
  memoryModel: "Memory model",
  modelAutomatic: "Automatic",
  modelAutomaticCheapest: "Automatic — cheapest",
  modelAutomaticLower: "automatic",
  modelValue: "{runner}, {model}",
  configuredModel: "Configured model",
  conversationSummaries: "Conversation summaries",
  summariesRecent: "{count} recent",
  summariesLine: "Past seven days, up to 10",

  valueStatement: "Statement",
  valueTitle: "Title",
  valueName: "Name",
  valueDescription: "Description",
  valueValue: "Value",
  valueContent: "Content",
  valueBody: "Details",
  valueSteps: "Steps",
  valuePurpose: "Purpose",
  valueKey: "Preference",
  proposalLoadError: "Couldn’t load this memory.",
  decisionSaveError: "Couldn’t save your decision. Try again.",
  noLongerWaiting: "This memory is no longer waiting for review.",
  current: "Current",
  proposed: "Proposed",
  accept: "Accept",
  reject: "Reject",

  summariesLoadError: "Couldn’t load summaries.",
  loadingSummaries: "Loading summaries…",
  recentSummaries: "Recent summaries",
  noSummaries: "No summaries this week.",
  summariesCount: {
    one: "{count} recent summary from the past seven days.",
    other: "{count} recent summaries from the past seven days.",
  },
} as const;
